import { useRef } from 'react';
import { assignCardSlots, cardKind, createCardSlotPool } from '../cardSlots';

/**
 * Slot ids stay stable across pans. Task objects are refreshed every render
 * so a reused slot sees the mission that now occupies it.
 */
export default function useCardSlots(tasks) {
  const poolRef = useRef(null);
  if (!poolRef.current) poolRef.current = createCardSlotPool();

  const signature = tasks.map((task) => `${task.id}:${cardKind(task)}`).join('\n');
  const cacheRef = useRef({ signature: '', assigned: [] });

  if (cacheRef.current.signature !== signature) {
    cacheRef.current.assigned = assignCardSlots(poolRef.current, tasks);
    cacheRef.current.signature = signature;
  }

  const byId = new Map(tasks.map((task) => [task.id, task]));
  return cacheRef.current.assigned.map((slot) => ({
    slotId: slot.slotId,
    task: byId.get(slot.task.id) || slot.task,
  }));
}
